import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

import CanvasActions from "../../actions/CanvasActions.js";

import "./style.css";

class DateComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      day: 1,
      month: 1,
      year: 2019
    };
  }

  componentDidMount() {
    let day, month, year;
    let timeStamp = new Date(this.props.canvas.timeDate);
    day = timeStamp.getDate();
    month = timeStamp.getMonth();
    year = timeStamp.getFullYear();

    this.setState({
      day,
      month,
      year
    });
  }

  dateChange(day, month, year) {
    let timeStamp = new Date(year, month, day, 12, 0);

    this.props.setCanvas({
      ...this.props.canvas,
      timeDate: timeStamp,
      day: day,
      month: month,
      year: year
    });
  }

  render() {
    return (
      <div className="date-picker">
        <div className="info">
          <p>Date a special event took place</p>
        </div>

        <div className="input">
          <input
            type="text"
            value={this.state.day}
            onChange={e => {
              this.setState({ day: e.target.value });
              this.dateChange(
                e.target.value,
                this.state.month,
                this.state.year
              );
            }}
          />
          <select
            value={this.state.month}
            onChange={e => {
              this.setState({ month: e.target.value });
              this.dateChange(this.state.day, e.target.value, this.state.year);
            }}
          >
            <option value={0}>January</option>
            <option value={1}>February</option>
            <option value={2}>March</option>
            <option value={3}>April</option>
            <option value={4}>May</option>
            <option value={5}>June</option>
            <option value={6}>July</option>
            <option value={7}>August</option>
            <option value={8}>September</option>
            <option value={9}>October</option>
            <option value={10}>November</option>
            <option value={11}>December</option>
          </select>
          <input
            type="text"
            value={this.state.year}
            onChange={e => {
              this.setState({ year: e.target.value });
              this.dateChange(this.state.day, this.state.month, e.target.value);
            }}
          />
        </div>

        {/* <DatePicker
          selected={this.props.canvas.timeDate}
          onChange={date => {
            this.props.setCanvas({
              ...this.props.canvas,
              timeDate: date
            });
          }}
          showYearDropdown
          focusOnShow={false}
          dateFormatCalendar="MMMM"
          // dateFormat="MMM Do YYYY"
          scrollableYearDropdown
        /> */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    canvas: state.canvas
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCanvas: canvas => {
      dispatch(CanvasActions.setCanvas(canvas));
    }
  };
};

const App = connect(
  mapStateToProps,
  mapDispatchToProps
)(DateComp);

export default App;



// WEBPACK FOOTER //
// ./src/components/DatePicker/index.js